import { useState, useEffect } from "react";
import { Grid, Box, Typography, Pagination } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import VisitsListingTable from "../../components/tables/VisitsListingTable";
import Spinner from "../../components/layout/Spinner";
import SearchFeedback from "../../components/feedback/SearchFeedback";
import Colors from "../../constants/Colors";

export const ListVisits = (): JSX.Element => {
  const navigate = useNavigate();
  const [visits, setVisits] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchVisits = async () => {
    setIsLoading(true);

    const API_URL = localStorage.getItem("apiUrl");
    const token = localStorage.getItem("token");

    if (!API_URL || !token) {
      setIsError(true);
      setIsLoading(false);
      return;
    }

    try {
      const savedParams = localStorage.getItem("visitSearchParams");
      const queryParams = new URLSearchParams();

      queryParams.append("page", String(page));

      if (savedParams) {
        const params = JSON.parse(savedParams);

        if (params.cliente) {
          queryParams.append("cliente", params.cliente);
        }

        if (params.emissaoInicial) {
          queryParams.append("emissaoInicial", params.emissaoInicial);
        }

        if (params.emissaoFinal) {
          queryParams.append("emissaoFinal", params.emissaoFinal);
        }

        if (params.situacaoId) {
          const situacao = Array.isArray(params.situacaoId)
            ? params.situacaoId.join(",")
            : params.situacaoId;

          queryParams.append("situacao", situacao);
        }

        if (params.tipoVisita) {
          const tipoVisita = Array.isArray(params.tipoVisita)
            ? params.tipoVisita.join(",")
            : params.tipoVisita;

          queryParams.append("tipoVisita", tipoVisita);
        }

        if (params.vendedorId) {
          queryParams.append("vendedorId", params.vendedorId);
        }
      }

      // Use roles from login as vendedorId filter
      const rolesStr = localStorage.getItem("roles");
      const roles = rolesStr ? JSON.parse(rolesStr) : [];

      if (roles.length > 0) {
        queryParams.append("vendedorId", roles.join(","));
      }

      const url = `${API_URL}/visitas?${queryParams.toString()}`;
      console.log(url);

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // console.log(response.data.visitas);

      setVisits(response.data.visitas || []);

      setTotalPages(response.data.totalPages || 1);
      setIsError(false);
    } catch (error) {
      console.error("Erro ao buscar visitas:", error);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchVisits();
  }, [page]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setPage(value);
  };

  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Typography variant="h6" color="error">
          Erro ao carregar lista de visitas.
        </Typography>
        <Typography variant="body2">
          Verifique sua conexão ou tente novamente mais tarde.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 0.5 }}>
      {/* Header */}
      <Grid container alignItems="center" sx={{ mb: 2 }}>
        <Grid item xs>
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              color: Colors.primary,
              ml: 1,
            }}
          >
            Lista de Visitas
          </Typography>
        </Grid>
      </Grid>

      {/* Table Content */}
      {visits.length === 0 ? (
        <SearchFeedback />
      ) : (
        <>
          <VisitsListingTable visits={visits} />
          {totalPages > 1 && (
            <Pagination
              size="small"
              showFirstButton
              showLastButton
              page={page}
              count={totalPages}
              sx={{
                mt: 2,
                "& .MuiPaginationItem-root": {
                  "&.Mui-selected": {
                    background: Colors.mainLayoutAtiveBackground,
                    color: "black",
                  },
                },
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
              }}
              onChange={handlePageChange}
            />
          )}
        </>
      )}
    </Box>
  );
};
